/* Built In Imports */
import { useState } from 'react';

/* External Imports */
import { Box, Image } from '@chakra-ui/react';
import { nanoid } from 'nanoid';
import Slider from 'react-slick';

/* Internal Imports */
/* Components */
// import { consoleLog } from '@components/Utility/Shared/SharedService';
import config from '@config';

/* Services */
/* Styles */
import 'react-image-lightbox/style.css';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';

/**
 * Render Slider Image Gallery Component
 *
 * @param sectionContent.sectionContent
 * @param {object} sectionContent
 * @returns {ReactElement} Slider Image Gallery Component
 */
const SliderImageGallery = ({ sectionContent }) => {
  const [slidecount, setSlidecount] = useState('');
  const [currentimage, setCurrentimage] = useState('');
  const images = sectionContent?.images?.map(function (image) {
    return image.url;
  });

  const updatecount = (props, obj) => {
    let currentslide = 1;
    obj === 'next' &&
      props.currentSlide != 0 &&
      (currentslide = props.currentSlide + 1);
    // : (currentslide = props.currentSlide + 1);
    setCurrentimage(currentslide);
  };
  const NextArrow = props => {
    const { onClick } = props;
    updatecount(props, 'next');
    return (
      <Box
        as="div"
        top="0"
        pos="absolute"
        // left="69%"
        right={{ base: '2%', sm: '2%', md: '0', lg: '0' }}
        height="300px"
        width={{ base: '25%', sm: '25%', md: '400px', lg: '400px' }}
        zIndex="10"
        textAlign={'center'}
        bg={{
          base: 'none',
          sm: 'none',
          md: 'linear-gradient(to left, #ffffff 0%, #ffffff35 100%)',
          lg: 'linear-gradient(to left, #ffffff 0%, #ffffff35 100%)',
        }}
      >
        <Box
          // cursor="pointer"
          pos="absolute"
          bgColor="#fff"
          border="0"
          borderRadius="100%"
          w={{ base: '32px', sm: '32px', md: '54px', lg: '54px' }}
          h={{ base: '32px', sm: '32px', md: '54px', lg: '54px' }}
          bgPos="center"
          bgRepeat="no-repeat"
          color="transparent"
          bgImage={`url(${config.staticPath}/assets/images/right-arrow.svg)`}
          right={{ xl: '50%', base: '-3%' }}
          top="50%"
          bgSize={{ base: '7px', sm: '7px', md: '13px', lg: '13px' }}
          onClick={onClick}
          boxShadow="rgba(0, 0, 0, 0.3) 0 0 15px 0"
        ></Box>
      </Box>
    );
  };

  const PrevArrow = props => {
    const { onClick } = props;
    updatecount(props, 'prev');
    return (
      <Box
        as="div"
        top="0"
        pos="absolute"
        left={{ base: '3%', sm: '3%', md: '0', lg: '0' }}
        height="300px"
        width={{ base: '0%', sm: '0%', md: '348px', lg: '348px' }}
        zIndex="10"
        textAlign={'center'}
        bg={{
          base: 'none',
          sm: 'none',
          md: 'linear-gradient(to right, #ffffff 0%, #ffffff35 100%)',
          lg: 'linear-gradient(to right, #ffffff 0%, #ffffff35 100%)',
        }}
      >
        <Box
          zIndex="10"
          pos="absolute"
          cursor="pointer"
          bgSize={{ base: '7px', sm: '7px', md: '13px', lg: '13px' }}
          bgColor="#fff"
          border="0"
          borderRadius="100%"
          w={{ base: '32px', sm: '32px', md: '54px', lg: '54px' }}
          h={{ base: '32px', sm: '32px', md: '54px', lg: '54px' }}
          bgPos="center"
          bgRepeat="no-repeat"
          color="transparent"
          bgImage={`url(${config.staticPath}/assets/images/left-arrow.svg)`}
          left={{ xl: '50%', base: '3%' }}
          top="50%"
          onClick={onClick}
          boxShadow="rgba(0, 0, 0, 0.3) 0 0 15px 0"
        />
      </Box>
    );
  };

  const settingsSmall = {
    dots: true,
    infinite: true,
    centerMode: true,
    // centerPadding: '60px',
    autoplay: true,
    lazyLoad: true,
    slidesToShow: 3,
    slidesToScroll: 3,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    centerPadding: 0,
    responsive: [
      {
        breakpoint: 1170,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 834,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
    ],
    appendDots: dots => (
      <div
        style={{
          backgroundColor: '#ddd',
          borderRadius: '10px',
          padding: '10px',
          display: 'none',
        }}
      >
        <ul style={{ margin: '0', display: 'none' }}> {dots} </ul>
      </div>
    ),
    customPaging: i => (
      <div
        style={
          {
            // display: 'none',
          }
        }
      >
        {setSlidecount(i + 1)};
      </div>
    ),
  };
  return (
    <>
      <Box
        p={{ sm: '0', xl: '0 30px' }}
        height="300px"
        id="slider-common"
        w={'100%'}
        mb="30px"
        className="image-gallery"
      >
        <Slider {...settingsSmall}>
          {sectionContent?.images?.map((item, index) => (
            <Box
              key={nanoid()}
              outline="none"
              textAlign={'center'}
              h="197px"
              mx="auto"
            >
              <Box
                m={{ base: '0 5px 0 0', lg: '0' }}
                height="300px"
                overflow="hidden"
                cursor="pointer"
                transition="all 0.5s linear"
                display="flex"
                justifyContent="center"
                alignItems="center"
              >
                <Image
                  width="328px"
                  height="197px"
                  transition="all 0.05s linear"
                  _active={{
                    transform: 'scale(1.25)',
                    w: '460px',
                    h: '300px',
                  }}
                  src={item.url}
                  alt={item.alt}
                  title={item.title}
                  objectFit={'cover'}
                  borderRadius="5px"
                />
              </Box>
            </Box>
          ))}
        </Slider>
        <style global jsx>
          {`
            .ril-next-button {
              position: absolute;
              top: 10%;
            }
            .ril-prev-button {
              position: absolute;
              top: 10%;
            }
            .ril__outer {
              background-color: rgba(0, 0, 0);
            }
            #slider-common .slick-slide img {
              max-width: 100%;
              opacity: 0.3;
              transition: transform 0.5s;
            }
            #slider-common .slick-slide.slick-center img {
              width: 460px;
              height: 300px;
              opacity: 1;
            }
            @media (max-width: 767px) {
              #slider-common .slick-slide.slick-center img {
                width: 100%;
              }
              #slider-common .slick-slide.slick-active {
                width: 0.9% !important;
              }
              #slider-common
                .slick-slide.slick-active.slick-center.slick-current {
                width: 345px !important;
                margin-left: 0px;
                margin-right: 0px;
              }
            }
          `}
        </style>
      </Box>
      <Box
        textAlign="center"
        fontFamily="FedraSansStd-book, sans-serif"
        fontSize="16px"
        fontWeight="600"
        mb="35px"
      >
        {currentimage} / {slidecount}
      </Box>
    </>
  );
};

export default SliderImageGallery;
